import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {
  TableCell,
  Table,
  TableBody,
  TableRow,
  TableHead,
} from "@material-ui/core";
import styles from "./styles";

const PreferredRouteWarningDialog = (props) => {
  const { classes, show, onClose, preferredRouteWarningData } = props;
  return (
    <Dialog
      open={show}
      onClose={onClose}
      aria-labelledby="publish-dialog"
      classes={{ paper: classes.publishDialog }}
    >
      <DialogTitle
        disableTypography={true}
        classes={{ root: classes.publishDialogTitle }}
        id="publish-dialog"
      >
        Customer Override Route Conflict
      </DialogTitle>
      <DialogContent classes={{ root: classes.publishDialogContent }}>
        <div>
          Optimization will automatically create customer override routes.
        </div>
        <div>
          Please rename the below routes (or) update customer override route
          names to avoid optimization failure due to conflict.
        </div>
        <div>
          <Table classes={{ root: classes.tableRoot }}>
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.tableHeadHeight}>
                <TableCell colSpan={3} className={classes.tableHeadCell}>
                  <div className={classes.routeNameInfo}>Customer Details</div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.tableHeaderCell}>
                  Customer Id
                </TableCell>
                <TableCell className={classes.tableHeaderCell}>
                  Customer Name
                </TableCell>
                <TableCell className={classes.tableHeaderCell}>Route</TableCell>
              </TableRow>
              {preferredRouteWarningData &&
                preferredRouteWarningData.map((item, index) => (
                  <TableRow className={classes.tableRow} key={index}>
                    <TableCell
                      className={`${classes.tableDataCell} ${classes.link}`}
                      onClick={() =>
                        props?.openCustomerDialog(item.customerCode)
                      }
                    >
                      {item.customerId}
                    </TableCell>
                    <TableCell
                      className={`${classes.tableDataCell} ${classes.link}`}
                      onClick={() =>
                        props?.openCustomerDialog(item.customerCode)
                      }
                    >
                      {item.customerName}
                    </TableCell>
                    <TableCell className={classes.tableDataCell}>
                      {item.route}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          className={classes.dialogButtonStyle}
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(PreferredRouteWarningDialog);
